import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface LeaveGuardProps {
  open: boolean;
  fieldName: string;
  onClose: () => void;
  onReturn: () => void;
  title?: string;
  message?: string;
}

export function LeaveGuard({ open, fieldName, onClose, onReturn, title, message }: LeaveGuardProps) {
  return (
    <Dialog
      open={open}
      onClose={onReturn}
      aria-labelledby="leave-guard-title"
      data-testid="leave-guard-dialog"
      PaperProps={{
        sx: {
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-elevated)",
          width: "560px",
          maxWidth: "calc(100vw - 32px)",
          p: 1,
        },
      }}
    >
      <DialogTitle
        id="leave-guard-title"
        data-testid="leave-guard-title"
        sx={{ fontWeight: 700, fontSize: 16, pb: 1 }}
      >
        {title ?? "変更が保存されていません"}
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography data-testid="leave-guard-message" variant="body2" sx={{ lineHeight: 1.7 }}>
          {message ?? `「${fieldName}」の編集内容が保存されていません。このまま閉じると、変更した内容は失われます。`}
        </Typography>
      </DialogContent>
      <DialogActions data-testid="leave-guard-footer" sx={{ px: 2, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          data-testid="leave-guard-close-button"
          sx={{ textTransform: "none" }}
        >
          保存せずに閉じる
        </Button>
        <Button
          variant="contained"
          onClick={onReturn}
          data-testid="leave-guard-return-button"
          sx={{ textTransform: "none" }}
        >
          編集に戻る
        </Button>
      </DialogActions>
    </Dialog>
  );
}
